import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        wrapper: {
            paddingBottom: 0,
        },

    }
})

export default useStyles
